import { IEconomicsCalculationsDailyValue } from '../../interfaces/ieconomics-calculations-daily-value';
import { Scenario } from '../scenario';
import { Well } from '../well';

export class EconomicsCalculationsDailyValueBase {
  EconomicsCalculationsDailyValueId: number;
  Scenarioid: number;
  WellId: number;
  Year: number | null;
  Day: number;
  Oil: number | null;
  NGL: number | null;
  Gas: number | null;
  Total: number | null;
  OilPrice: number | null;
  NGLPrice: number | null;
  GasPrice: number | null;
  CommodityPrice: number | null;
  Revenue: number | null;
  LOE: number | null;
  CashFlow: number | null;
  PaybackCalculation: number | null;
  WorkingInterest: number | null;
  DrillingProject: number | null;
  CompletionsProject: number | null;
  FacilitiesProjects: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Well?: Well;
  Scenario?: Scenario;

  constructor(item?: IEconomicsCalculationsDailyValue) {
    if (item) {

      this.EconomicsCalculationsDailyValueId = item.EconomicsCalculationsDailyValueId;
      this.Scenarioid = item.Scenarioid;
      this.WellId = item.WellId;
      this.Year = item.Year;
      this.Day = item.Day;
      this.Oil = item.Oil;
      this.NGL = item.NGL;
      this.Gas = item.Gas;
      this.Total = item.Total;
      this.OilPrice = item.OilPrice;
      this.NGLPrice = item.NGLPrice;
      this.GasPrice = item.GasPrice;
      this.CommodityPrice = item.CommodityPrice;
      this.Revenue = item.Revenue;
      this.LOE = item.LOE;
      this.CashFlow = item.CashFlow;
      this.PaybackCalculation = item.PaybackCalculation;
      this.WorkingInterest = item.WorkingInterest;
      this.DrillingProject = item.DrillingProject;
      this.CompletionsProject = item.CompletionsProject;
      this.FacilitiesProjects = item.FacilitiesProjects;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Well = new Well(item.Well);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}